import { render, staticRenderFns } from "./CustomQuestionItem.vue?vue&type=template&id=8b934896&scoped=true&"
import script from "./CustomQuestionItem.vue?vue&type=script&lang=js&"
export * from "./CustomQuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomQuestionItem.vue?vue&type=style&index=0&id=8b934896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b934896",
  null
  
)

export default component.exports